import React, { memo } from 'react';
import { useWtrSelector } from 'redux/hooks';
import { getProductPromotions } from 'redux/modules/product-details/selectors/product-pricing';
import { getPromotionsByIds } from 'redux/modules/entities/selectors/promotions';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { ProductPodPromotions as DSProductPodPromotions } from '@johnlewispartnership/wtr-ingredients/ingredients/ProductPodPromotions';
import { makeDSPromo } from './utils/productToDSProduct';

const ProductPodPromotions = ({ productId, currentSaleUnitPrice }) => {
  const promotionIds = useWtrSelector(state => getProductPromotions(state, productId), isEqual);
  const promotions = useWtrSelector(
    state => getPromotionsByIds(state, promotionIds || []),
    isEqual,
  );

  if (promotions.length < 1) return null;

  return (
    <DSProductPodPromotions
      currentSaleUnitPrice={currentSaleUnitPrice}
      productId={productId}
      promotions={promotions
        .filter(promo => !promo.hidden)
        .slice(0, 2)
        .map(makeDSPromo)}
    />
  );
};

ProductPodPromotions.displayName = 'ProductPodPromotions';

ProductPodPromotions.propTypes = {
  productId: PropTypes.string.isRequired,
  currentSaleUnitPrice: PropTypes.shape({
    price: PropTypes.shape({
      amount: PropTypes.number,
      currencyCode: PropTypes.string,
    }),
    quantity: PropTypes.shape({
      amount: PropTypes.number,
      uom: PropTypes.string,
    }),
  }).isRequired,
};

export default memo(ProductPodPromotions);
